import React from "react";
import { View, Text } from "@react-pdf/renderer";
import Styles from "../Styles";

const EmployerFieldRow = ({ styles, label }) => (
  <View
    style={{
      width: "100%",
      flexDirection: "row",
      alignItems: "flex-start",
      marginBottom: 4,
    }}
  >
    <Text
      style={{
        ...styles.ButtonTextSmall,
        width: 150,
        flexShrink: 0,
        marginRight: 6,
      }}
      wrap={false}
    >
      {label}
    </Text>
    <View style={{ ...styles.line }} />
  </View>
);

const MembershipOption = ({ styles, prefix, text }) => (
  <View
    style={{
      width: "48%",
      flexDirection: "row",
      alignItems: "flex-start",

    }}
  >
    <View style={{ ...styles.numberBox, marginTop: 1, marginRight: 6 }} />
    <Text
      style={{
        ...styles.LabelSmallSemiBold,
        flexShrink: 1,
      }}
    >
      {prefix} <Text style={{ ...styles.ButtonTextSmall }}>{text}</Text>
    </Text>
  </View>
);

const EmployerDetails = ({ primaryColor = "081e56" }) => {
  const styles = Styles(primaryColor);

  return (
    <View style={{ ...styles.FlexStartColumn, gap: 0 }}>
      <Text style={styles.ContentSemiBold}>Employer’s Details</Text>

      <View style={styles.panel}>
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            marginBottom: 4,
gap:20,
          }}
        >
          <View style={{ width: "48%" }}>
            <EmployerFieldRow styles={styles} label="Company Name" />
            <EmployerFieldRow styles={styles} label="Payroll No." />
            <EmployerFieldRow styles={styles} label="National Insurance" />
          </View>



          <View style={{ width: "48%" }}>
            <EmployerFieldRow styles={styles} label="Tel No." />
            <EmployerFieldRow styles={styles} label="Please Contact" />
          </View>
        </View>

        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <MembershipOption
            styles={styles}
            prefix="Not"
            text="a member of the company pension scheme"
          />
          <MembershipOption
            styles={styles}
            prefix="Am"
            text="a member of the company pension scheme"
          />
        </View>
      </View>
    </View>
  );
};

export default EmployerDetails;
